import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export interface ConfirmationDialogProps {
  open: boolean;
  title?: string;
  body?: string;
  declineText?: string;
  confirmText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmationDialog({
  open,
  title,
  body,
  declineText,
  confirmText,
  onConfirm,
  onCancel,
}: ConfirmationDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="xs" onClose={onCancel}>
      {title && <DialogTitle>{title}</DialogTitle>}

      {body && (
        <DialogContent dividers>
          <Typography>{body}</Typography>
        </DialogContent>
      )}

      <DialogActions>
        <Button autoFocus onClick={onCancel}>
          {declineText || t('confirmation.buttons.decline')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {confirmText || t('confirmation.buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
